module.exports = __webpack_public_path__ + "img/lock.937f1503.svg";